// extracted by mini-css-extract-plugin
export default {"tabsBackground":"#fff","tabTextColor":"#474747","selectedTabTextColor":"#fff","selectedTabBackground":"var(--color-background-primary)"};